import { statisticsSchema } from '../schema/Statistiques.ts';
import { validateData } from '../utils/utils.ts';
import { api } from './client.ts';
import { getStatisticsUrl } from './constants.ts';

export async function getStatistics(
  territorySlug: string,
  queryParameters: Record<string, string>,
  signal?: AbortSignal,
) {
  const validatedData = validateData(statisticsSchema, queryParameters, 'Statistics');
  return await api.get(getStatisticsUrl(territorySlug, validatedData), { signal });
}
